$(document).ready(function(){
	$('.testi-wrapper_new').slick({
		dots: false,
		infinite: true,
		speed: 2000,
		slidesToShow: 5.5,  // Shows 5 full images + 6th half-visible on the left
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 3000,
		arrows: false,  
		variableWidth: false, 
		responsive: [
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 480,
				settings: {
					slidesToShow: 2.5,
					slidesToScroll: 1
				}
			},
			{
				breakpoint: 1024,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 1
				}
			}
		]
	});
	$('.logo-slider').slick({
		slidesToShow: 5,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 0,  // No delay
		speed: 3000,  // Smooth continuous effect
		cssEase: 'linear',  // Ensures smooth motion
		infinite: true,
		arrows: false,
		dots: false,
		pauseOnHover: false,
		swipe: false,
		centerMode: true,
		variableWidth: true,
	});
    $('.testi-wrapper').slick({
    	dots: false,
    	infinite: true,
    	speed: 2000,
    	slidesToShow: 5,
    	slidesToScroll: 1,
    	autoplay: true,
    	autoplaySpeed: 300,
    	responsive: [
    		{
    			breakpoint: 768,
    			settings: {
    				slidesToShow: 2,
    				slidesToScroll: 1
    			}
    		},
    		{
    		breakpoint: 480,
    			settings: {
    				slidesToShow: 1,
    				slidesToScroll: 1
    			}
    		},
    		{
    			breakpoint: 1024,
    			settings: {
    				slidesToShow: 3,
    				slidesToScroll: 1
    			}
    		}
    	]
    });
});
 $('.testi-inner').slick({
    	dots: false,
    	infinite: true,
    	speed: 2000,
    	slidesToShow: 5,
    	slidesToScroll: 1,
    	autoplay: true,
    	autoplaySpeed: 300,
    	responsive: [
    		{
    			breakpoint: 768,
    			settings: {
    				slidesToShow: 2,
    				slidesToScroll: 1
    			}
    		},
    		{
    		breakpoint: 480,
    			settings: {
    				slidesToShow: 1,
    				slidesToScroll: 1
    			}
    		},
    		{
    			breakpoint: 1024,
    			settings: {
    				slidesToShow: 3,
    				slidesToScroll: 1
    			}
    		}
    	]
    });

document.querySelectorAll('.review-video').forEach(function(video) {
	var playButton = video.nextElementSibling;
	video.addEventListener('click', function() {
		if (video.paused) {
			video.play();
			playButton.style.display = 'none';
		} else {
			video.pause();
			playButton.style.display = 'block';
		}
	});
	video.addEventListener('play', function() {
		playButton.style.display = 'none';
	});
	video.addEventListener('pause', function() {
		playButton.style.display = 'block';
	});
	playButton.addEventListener('click', function() {
		if (video.paused) {
			video.play();
			playButton.style.display = 'none';
		}
	});
});
var mainSlider = $('.custom-prod-media-gallery .main-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
});
$('.custom-prod-media-gallery .thumbnail-button').first().addClass('active');

$('.custom-prod-media-gallery .main-slider').on('mousemove', function(event) {
    var sliderOffset = $(this).offset();

    var cursorX = event.clientX - sliderOffset.left;
    var cursorY = event.clientY - sliderOffset.top;

    cursorY += $(window).scrollTop();

    $('.custom-prod-media-gallery .product-gallery__cursor').css({
        transform: `translate(${cursorX}px, ${cursorY}px)`
    });

    var midPoint = $(this).width() / 2;

    if (cursorX < midPoint) {
        $('.custom-prod-media-gallery .product-gallery__cursor svg').css('transform', 'rotate(180deg)');
    } else {
        $('.custom-prod-media-gallery .product-gallery__cursor svg').css('transform', 'rotate(0deg)');
    }
});
$('.custom-prod-media-gallery .main-slider').on('click', function(event) {
    var midPoint = $(this).width() / 2;
    var sliderOffset = $(this).offset();
    var cursorX = event.clientX - sliderOffset.left;

    if (cursorX < midPoint) {
        $('.custom-prod-media-gallery .main-slider').slick('slickPrev');
    } else {
        $('.custom-prod-media-gallery .main-slider').slick('slickNext');
    }
});

$('body').on('click','.custom-prod-media-gallery .thumbnail-button', function() {
    if ($(this).hasClass('active')) {
        $(this).removeClass('active');
    } else {
        $('.custom-prod-media-gallery .thumbnail-button').removeClass('active');
        $(this).addClass('active');
    }
    var slideIndex = $(this).data('slide');
    $('.custom-prod-media-gallery .main-slider').slick('slickGoTo', slideIndex);
});
$('.custom-prod-media-gallery .main-slider').on('afterChange', function(event, slick, currentSlide) {
    $('.custom-prod-media-gallery .thumbnail-button').removeClass('active');

    $('.custom-prod-media-gallery .thumbnail-button').eq(currentSlide).addClass('active');
});